// extracted by mini-css-extract-plugin
export default {"button":"Ak-z","reviewSort":"Bk-z"};